/**
 * Principal risk LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Pair } from './pair';

export interface PrincipalRiskExecutionLog {
  id?: number;
  timestamp?: string;
  comment?: string;
  pnl?: number;
  orderId?: number;
  chainId?: number;
  accountId?: number;
  account?: Account;
  pairId?: number;
  pair?: Pair;
}
